import { Image, Switch, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import Motion from "../Motion/Motion";
import { useProfileAppContext, PersistentActions } from "../../stores";
import { useI18N } from "@sundae/react-hooks";

const ErrorReportingDialog = () => {
  const { t } = useI18N("first-visits");
  const {
    dispatch,
    state: { errorReportingEnabled },
  } = useProfileAppContext();
  return (
    <Motion className="grid place-items-center gap-4 text-center">
      <Image
        className={cx("pointer-events-none w-56")}
        height={400}
        src="/static/images/dudes/wally_404_1024x1024.png"
        width={400}
      />

      <Text tag="h2" size="2xl" weight="bold">
        {t("errorReporting.title")}
      </Text>
      <Text tag="p">{t("errorReporting.copy")}</Text>

      <Text tag="div" size="xs" variant="silent" className="flex items-center justify-center gap-4">
        <Text tag="span" size="xs" variant="silent">
          {t("errorReporting.title")}{" "}
          {t(errorReportingEnabled ? "enabled" : "disabled", { ns: "common" })}
        </Text>
        <Switch
          containerClassName="justify-between scale-75"
          checked={errorReportingEnabled}
          size="sm"
          onCheckedChange={() => {
            PersistentActions.setErrorReporting(!errorReportingEnabled, dispatch);
          }}
        />
      </Text>
    </Motion>
  );
};

export default ErrorReportingDialog;
